// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
// import { rutas } from './router'
import Vue2Filters from 'vue2-filters'
import VueCurrencyFilter from 'vue-currency-filter'
import VueMoment from 'vue-moment'
import VueTouch from 'vue-touch'
import Main from './components/main/main.vue'
import InputQuery from '@/core/vue/components/input-query/input-query'
import InputQueryLocation from '@/core/vue/components/input-query-location/input-query'
import SeleccionUsuario from '@/core/vue/components/seleccion-usuario/seleccion-usuario.js'
import Store from '@/core/vue/store/stores'
import VueTheMask from 'vue-the-mask'
import VueCropper from './components/cropper/vue-cropper'
import Datepicker from 'vuejs-datepicker'
import JsonExcel from 'vue-json-excel'
import QRCode from '@xkeshi/vue-qrcode'
import VueMce from 'vue-mce'
import VCalendar from 'v-calendar'
import Modal from './components/modal/modal'
import MenuSuperior from './components/menu-superior/menu-superior'
// import VueCharts from 'vue-chartjs'
import BubbleChart from './config/charts'
import { es } from 'vuejs-datepicker/dist/locale'
import vueSignature from 'vue-signature'
import misRutas from 'vue-routes-generator'
import VueRouter from 'vue-router'
import { v4, validate } from 'uuid'
import NoEncontrado from './components/main/404.vue'
import AvatarComponent from './components/common/avatar'
import Imprimir from './components/imprimir/imprimir.vue'
import FiltroTamano from './libs/filtroTamano'
import Round from './libs/round'
import FiltroHora from './libs/filtroHora'
import Downloader from './libs/download'
import swFichar from './libs/swFichar'

import 'chart.js'
import 'hchs-vue-charts'

import 'lodash'
// Bootstrap
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css'
// import './assets/bootstrap.min.css'
import '../../../../node_modules/font-awesome/css/font-awesome.min.css'

// IMPORTAMOS LOS FICHEROS DE RUTAS DE TODOS LOS MÓDULOS
misRutas.route('/main', {
	component: Main
})
// eslint-disable-next-line
import '../../../../modulos.js'

Vue.use(VueRouter)
misRutas.route('/main').child('*', {
	name: 'Error sección 404',
	component: NoEncontrado
})
misRutas.route('/', {
	redirect: '/main'
})
misRutas.route('*', {
	name: 'Error 404',
	component: NoEncontrado
})
const r = misRutas.export()
let miRouter = new VueRouter({
	routes: r
})
Vue.config.productionTip = false
Vue.use(vueSignature)
Vue.use(VueTouch)
Vue.use(Vue2Filters)

Vue.use(VueCurrencyFilter, {
	symbol: '€',
	thousandsSeparator: '.',
	fractionCount: 2,
	fractionSeparator: ',',
	symbolPosition: 'back',
	symbolSpacing: true
})

Vue.use(VueMoment)
Vue.use(InputQuery)
Vue.use(InputQueryLocation)
Vue.use(SeleccionUsuario)
Vue.use(VueTheMask)
Vue.use(VueCropper)
Vue.use(VueMce)
Vue.use(FiltroTamano)
Vue.use(FiltroHora)
Vue.use(Round)
Vue.use(Downloader)
Vue.use(swFichar)
Vue.component('modal', Modal)
Vue.component('menu-superior', MenuSuperior)
Vue.use(BubbleChart)
Vue.use(window.VueCharts)

Vue.use(VCalendar, {
	componentPrefix: 'vc',
	locale: 'es'
})

Vue.component('qrcode', QRCode)
Vue.component('datepicker', Datepicker)
Vue.component('downloadExcel', JsonExcel)
Vue.component('avatar', AvatarComponent)
Vue.component('imprimir', Imprimir)

Vue.prototype.$error = (titulo, mensaje) => {
	if (!mensaje) {
		titulo = 'Error'
		mensaje = titulo
	}
	Store.commit('alertas/error', {
		titulo: titulo,
		mensaje: mensaje
	})
}

Vue.prototype.$alert = (titulo, mensaje) => {
	if (!mensaje) {
		titulo = 'Alerta'
		mensaje = titulo
	}
	Store.commit('alertas/alert', {
		titulo: titulo,
		mensaje: mensaje
	})
}

Vue.prototype.$confirm = (titulo, mensaje, callback) => {
	Store.commit('alertas/confirm', {
		titulo: titulo,
		mensaje: mensaje,
		callback: callback
	})
}

Vue.prototype.$http = axios

Vue.prototype.$dateLang = es

Vue.prototype.$responseError = (e) => {
	const error = (e && e.response && e.response.data && e.response.data.error) ? e.response.data.error : 'Error desconocido'
	Store.commit('alertas/error', {
		titulo: 'Error',
		mensaje: error
	})
}

Vue.prototype.$uuid = {
	generate: v4,
	validate
}

/* eslint-disable no-new */
new Vue({
	el: '#sip-app',
	router: miRouter,
	store: Store,
	template: '<App/>',
	components: { App }
})



// WEBPACK FOOTER //
// ./src/modulos/core/vue/main.js